export const GRID = 'GRID';
export const LIST = 'LIST';
export const DAY = 'day';
export const TAG = 'tag';
